import { canRunCoverage } from "./utils/canRunCoverage.js";
import { createDefaultLogger } from "./utils/createDefaultLogger.js";
import { defaultSkipElementChildren } from "./utils/defaultSkipElementChildren.js";
import { startDOMProcessing } from "./utils/startDOMProcessing.js";
async function createDOMIdentityCollection(config) {
  const {
    root,
    dsName,
    timingApi,
    createLogger = createDefaultLogger,
    enableLogging,
    forceCalculation,
    skipElementChildren = defaultSkipElementChildren,
    getComponentIdentity
  } = config;
  const timer = timingApi === "date" ? Date : timingApi === "performance" ? performance : void 0;
  const logger = createLogger(dsName, !enableLogging);
  const shouldRun = canRunCoverage({
    forceCalculation,
    logger
  });
  if (shouldRun) {
    const domStart = timer ? timer.now() : -1;
    const results = await startDOMProcessing({
      getComponentIdentity,
      logger,
      root,
      skipElementChildren
    });
    if (timer) {
      logger.log(`DOM processing took: ${timer.now() - domStart}ms`);
    }
    if (results) {
      const typedArrayStart = timer ? timer.now() : -1;
      logger.log("creating TypedArray");
      const identities = new Uint32Array(results);
      if (timer) logger.log(`TypedArray creation took: ${timer.now() - typedArrayStart}ms`);
      logger.success("done");
      return identities;
    }
  }
}
export {
  createDOMIdentityCollection
};
//# sourceMappingURL=createDOMIdentityCollection.js.map
